import { exposedJSMethods } from './exposedJSMethods';
import { GREMLIN_KEYWORDS } from './gremlinKeywords';

export enum EditorLanguage {
  GROOVY = 'groovy',
  JAVASCRIPT = 'javascript',
  JSON = 'json',
}

export interface AceCompleter {
  getCompletions: (
    editor: any,
    session: any,
    pos: number,
    prefix: string,
    callback: any
  ) => void;
}

interface CompletionElement {
  value: string;
  meta: string;
}

/* Helper for ace editor to create an autocomplete object */
const customAceCompleter = (array: CompletionElement[]): AceCompleter => ({
  getCompletions: (_editor, _session, _pos, _prefix, callback) => {
    callback(
      null,
      array.map(({ value, meta }) => ({
        name: value,
        value,
        score: 1,
        meta,
      }))
    );
  },
});

/* Completer with extra keywords for the plugin editor */
const pluginCompleter = customAceCompleter(
  exposedJSMethods.map(value => ({ value, meta: 'local' }))
);

/* Completer with extra keywords for the gremlin editor */
const gremlinCompleter = customAceCompleter(
  GREMLIN_KEYWORDS.map(value => ({ value, meta: 'gremlin' }))
);

export const getCompleters = (
  localCompleter: AceCompleter,
  modeCompleter: AceCompleter,
  language: EditorLanguage
) => {
  if (language === EditorLanguage.JAVASCRIPT) {
    return [pluginCompleter, localCompleter, modeCompleter];
  } else if (language === EditorLanguage.GROOVY) {
    return [gremlinCompleter, localCompleter];
  } else if (language === EditorLanguage.JSON) {
    return [localCompleter, modeCompleter];
  }
};
